// extracted by mini-css-extract-plugin
export default {"footer":"HrUsers_footer__bVxjv","footerTheme":"HrUsers_footerTheme__Evhha"};